module.exports = __webpack_public_path__ + "img/modelo.2862ad00.png";